<template>
  <div id="contenedor-listado-reporte-ejecutivo">
    <v-data-table
      :headers="headers"
      :items="listado"
      :items-per-page="20">
      <template v-slot:[`item.fecha`]="{ item }">
        {{ new Date(`${item.fecha} 00:00:0`).toLocaleDateString() }}
      </template>
      <template v-slot:[`item.contrato.numero`]="{ item }">
        <b>{{ item.contrato.numero }}</b>
      </template>
      <template v-slot:[`item.avanceProgramado`]="{ item }">
        <v-chip
          color="naranja2"
          small>
          {{ item.avanceProgramado }}%
        </v-chip>
      </template>
      <template v-slot:[`item.avanceFisico`]="{ item }">
        <v-chip
          color="azul1"
          small>
          {{ item.avanceFisico }}%
        </v-chip>
      </template>
      <template v-slot:[`item.avanceFinanciero`]="{ item }">
        <v-chip
          color="verde1"
          small>
          {{ item.avanceFinanciero }}%
        </v-chip>
      </template>
      <template v-slot:[`item.porcentajeDeAtraso`]="{ item }">
        <v-chip
          class="mr-2"
          :color="item.descripcionAtraso.color"
          :dark="item.descripcionAtraso.dark"
          small>
          {{ item.descripcionAtraso.texto }}
          <template
            v-if="item.porcentajeDeAtraso <= 0">
            <span
              class="font-weight-bold ml-1">
              {{ (item.porcentajeDeAtraso * -1) }}%
            </span>
          </template>
          <template
            v-else>
            <span
              class="font-weight-bold ml-1">
              {{ item.porcentajeDeAtraso }}%
            </span>
          </template>
        </v-chip>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano
          :fecha="item.createdAt">
        </fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoReporteEjecutivo',
  components: {
    FechaHumano,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
    imprimir: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: '#',
          align: 'center',
          sortable: false,
          value: 'numero',
        },
        {
          text: 'Fecha',
          align: 'center',
          value: 'fecha',
        },
        { text: 'Núm. Contrato', value: 'contrato.numero' },
        { text: 'Supervisor', value: 'supervisor.funcionario.nombre' },
        { text: 'Av. Prog.', value: 'avanceProgramado' },
        { text: 'Av. Fis.', value: 'avanceFisico' },
        { text: 'Av. Fin.', value: 'avanceFinanciero' },
        { text: 'Atraso', value: 'porcentajeDeAtraso' },
        { text: 'Comentarios', value: 'comentarios' },
        { text: 'F. Reg.', value: 'createdAt' },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
